import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const RoomSkeleton = () => {
  return (
    <Box
      style={{ width: '100%' }}
      height="full"
      position="relative"
      paddingY="s16"
      gap="s16"
      alignItems="center"
    >
      <Box
        style={{ width: '100%' }}
        height="full"
        position="relative"
        gap="s24"
        flexDirection="row"
        paddingLeft="s24"
      >
        <Skeleton isLoading height="full" />
        <Box style={{ width: '700px' }} flexNoShrink paddingRight="s24">
          <Skeleton height="full" isLoading />
        </Box>
      </Box>
      <Box
        style={{ maxWidth: '450px', width: '100%' }}
        height="s64"
        position="relative"
        gap="s4"
        paddingBottom="s16"
        flexDirection="row"
      >
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
        <Skeleton isLoading height="full" />
      </Box>
    </Box>
  )
}
